'use client';
import { IconChevronRight } from '@tabler/icons-react';
import { Cbutton } from '@/components/ui/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import { CWITNESSCARDMODAL_BACK_BUTTON_STYLE } from './cwitnesscardmodalStyles';
interface CwitnesscardmodalBackButtonProps {
    onClose: () => void;
}
export function CwitnesscardmodalBackButton({ onClose, }: CwitnesscardmodalBackButtonProps) {
    return <div style={CWITNESSCARDMODAL_BACK_BUTTON_STYLE}>
            <Cbutton rootAttributes={{ "data-el": "Cwitnesscardmodal/BackButton/CloseTrigger" }} preset={ButtonPreset.Secondary} icon={IconChevronRight} iconSize={24} onClick={onClose} containerStyle={{ width: '2.5rem', height: '2.5rem' }}/>
        </div>
        ;
}
